// noinspection JSUnresolvedReference,JSUnusedGlobalSymbols

/* Модуль для удобства использования сгенерированной конфигурации в IDE.
 * В частности, для корректной работы автодополнения.
 *
 * Справочный пример команды для извлечения описаний из файла JavaScript:
 *     npx -p typescript tsc KsaLoginConfig.js --declaration --allowJs --emitDeclarationOnly --outDir types
 */

const KsaLoginConfig = window.__ksa_login_config_module__.KsaLoginConfig;

export {
    KsaLoginConfig as default,
    KsaLoginConfig
}
